import SearchResultContainer from './SearchResultContainer';
export default SearchResultContainer;